import { observable } from 'mobx';
import { Resource } from './Resource';
import { DataSourceProvider, DataSource } from './DataSourceProvider';
import * as moment from 'moment';

export interface ResourceCollectionConfig {
  dataSource: string | DataSource;
  name: string;
  fields: string[];
  args?: { [key: string]: any };
}

interface ResourceCollectionData {
  items: any[];
  count: number;
}

export class ResourceCollection {
  name: string;
  dataSource: DataSource;
  fields: string[];
  args?: { [key: string]: any };
  start: number;
  time: number = 0;
  times: Array<any> = [];

  // fault resources has updated their configuration and needs to be reloaded
  fault: boolean = true;
  @observable loading: boolean = false;
  @observable data?: any | null;

  constructor(config: ResourceCollectionConfig) {
    if (typeof config.dataSource === 'string') {
      this.dataSource = DataSourceProvider.shared().getDataSource(
        config.dataSource
      );
    } else {
      this.dataSource = config.dataSource;
    }
    this.name = config.name;
    this.fields = config.fields;
    this.args = config.args;
    this.start = new Date().getTime();
  }

  reloadIfNeeded = async () => {
    if (this.fault) {
      return this.reload();
    }
  };

  reload = async () => {
    return this.get();
  };

  setArgs(args: { [key: string]: any }) {
    this.args = args;
    this.fault = true;
  }

  get = async () => {
    this.loading = true;
    this.fault = false;
    let start = new Date().getTime();

    //filtruji se pozadavky co problehly pred 2m
    this.times = this.times.filter((f: any) => f.start > (start - 120000))

    this.times.push({
      start: start,
      end: null,
      res: {}
    });
    
    const res = (await this.dataSource.list(
      this.name,
      this.fields,
      this.args || {}
    )) as ResourceCollectionData;
    //console.log('get', res, this.args);

    if (res) {
      let { items, count } = res;

      items = items.map(i => {
        i.delete = async () => {
          await this.delete(i.id);
          await this.reload();
        };
        return i;
      });

      const time = this.times.find(f => f.start === start) || {};
      time.end = new Date().getTime();
      time.res = res;

      this.data = { items, count };
      //console.log("GET Konec", this.start, this.time, res);
    }

    this.loading = false;
  };

  update = async (id: string, values: Object, args?: any) => {
    const resource = new Resource({
      id: id,
      dataSource: this.dataSource.name,
      name: this.name,
      fields: this.fields
    });
    this.start = new Date().getTime();
    await resource.update(values, args);
    this.time = this.start - new Date().getTime();
  };

  custom = async (name: string, id: string, values: Object, args?: any) => {
    const resource = new Resource({
      id: id,
      dataSource: this.dataSource.name,
      name: this.name,
      fields: this.fields
    });
    this.start = new Date().getTime();
    await resource.custom(name, values, args);
    this.time = this.start - new Date().getTime();
  };

  delete = async (id: string) => {
    const resource = new Resource({
      id: id,
      dataSource: this.dataSource.name,
      name: this.name,
      fields: this.fields
    });
    this.start = new Date().getTime();
    await resource.delete();
    this.time = this.start - new Date().getTime();
  };
}



// WEBPACK FOOTER //
// ./src/store/ResourceCollection.ts